<ng-container *ngIf="searchParams">
  <wlx-tabs #formTabs>
    <wlx-tab #tabInvoiceInfo [title]="'revenue.invoice-selector.form.invoice-info.tab-title' | translate | titlecase">
      <div class="container-fluid">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-12">
              <button
                app-add-button
                [label]="'revenue.invoice-selector.form.add-search-field' | translate | titlecase"
                (click)="handleAddInvoiceInfoSearchField()"
              ></button>
            </div>
          </div>
          <div
            class="mb-10 mct-flex mct-row mct-justify-start mct-items-center"
            *ngFor="let searchExpression of searchParams.InvoiceInfoSearchExpressions; let ndx = index"
          >
            <div>
              <button
                pButton
                type="button"
                class="atlas-btn atlas-btn-default"
                icon="pi pi-times"
                (click)="handleRemoveInvoiceInfoSearchField(ndx)"
              ></button>
            </div>
            <wl-expression
              class="wl-expression-row"
              [searchExpression]="searchExpression"
              [binarySelectorHidden]="!ndx"
              [showBetweenDateOption]="false"
            >
              <wl-expression-option
                fieldName="InvoiceNum"
                [displayName]="'revenue.invoice-selector.form.invoice-info.options.invoice-number' | translate | titlecase"
              ></wl-expression-option>
              <wl-expression-option
                fieldName="Batch_Creation"
                [displayName]="'revenue.invoice-selector.form.invoice-info.options.batch-number' | translate | titlecase"
              ></wl-expression-option>
              <wl-expression-option
                fieldName="Batch_Posting"
                [displayName]="'revenue.invoice-selector.form.invoice-info.options.posting-batch-number' | translate | titlecase"
              ></wl-expression-option>
              <wl-expression-option
                fieldName="InvoiceDate"
                [displayName]="'revenue.invoice-selector.form.invoice-info.options.invoice-date' | translate | titlecase"
                [fieldType]="fieldTypeEnum.Date"
              ></wl-expression-option>
              <wl-expression-option
                fieldName="DateDue"
                [displayName]="'revenue.invoice-selector.form.invoice-info.options.due-date' | translate | titlecase"
                [fieldType]="fieldTypeEnum.Date"
              ></wl-expression-option>
              <wl-expression-option
                fieldName="InvoiceSent"
                [displayName]="'revenue.invoice-selector.form.invoice-info.options.sent-status' | translate | titlecase"
                [fieldType]="fieldTypeEnum.Bool"
                [trueLabel]="'revenue.invoice-selector.form.invoice-info.sent-status-sent-label' | translate | titlecase"
                [falseLabel]="'revenue.invoice-selector.form.invoice-info.sent-status-not-sent-label' | translate | titlecase"
              ></wl-expression-option>
              <wl-expression-option
                fieldName="Profile_PreferredBillingMethod"
                [displayName]="'revenue.invoice-selector.form.invoice-info.options.preffered-billing' | translate | titlecase"
              >
                <wl-expression-option-dropdown-option
                  [value]="'E-Mail'"
                  [label]="'revenue.invoice-selector.form.invoice-info.prefered-bililng-method-options.email-label' | translate | titlecase"
                ></wl-expression-option-dropdown-option>
                <wl-expression-option-dropdown-option
                  [value]="'Print'"
                  [label]="'revenue.invoice-selector.form.invoice-info.prefered-bililng-method-options.print-label' | translate | titlecase"
                ></wl-expression-option-dropdown-option>
                <wl-expression-option-dropdown-option
                  [value]="'Both'"
                  [label]="'revenue.invoice-selector.form.invoice-info.prefered-bililng-method-options.both-label' | translate | titlecase"
                ></wl-expression-option-dropdown-option>
                <wl-expression-option-dropdown-option
                  [value]="'Special Handling'"
                  [label]="
                    'revenue.invoice-selector.form.invoice-info.prefered-bililng-method-options.special-handling-label'
                      | translate
                      | titlecase
                  "
                ></wl-expression-option-dropdown-option>
              </wl-expression-option>
              <wl-expression-option
                fieldName="ProfileId"
                [displayName]="'revenue.invoice-selector.form.invoice-info.options.profileid' | translate | titlecase"
              ></wl-expression-option>
            </wl-expression>
          </div>
        </div>
      </div>
    </wlx-tab>
    <wlx-tab [title]="'revenue.invoice-selector.form.aging.tab-title' | translate | titlecase">
      <div class="container-fluid">
        <div class="form-horizontal">
          <ul class="list-unstyled">
            <li>
              <label>
                <wl-radio-checkbox
                  [(ngModel)]="searchParams.AgingPeriod"
                  [uncheckedValue]="agingPeriodEnum.None"
                  [value]="agingPeriodEnum.AllOpen"
                ></wl-radio-checkbox>
                {{ 'revenue.invoice-selector.form.aging.options.all-open' | translate | titlecase }}
              </label>
            </li>
            <li>
              <label>
                <wl-radio-checkbox
                  [(ngModel)]="searchParams.AgingPeriod"
                  [uncheckedValue]="agingPeriodEnum.None"
                  [value]="agingPeriodEnum.AllPastDue"
                ></wl-radio-checkbox>
                {{ 'revenue.invoice-selector.form.aging.options.all-past-due' | translate | titlecase }}
              </label>
            </li>
            <li>
              <label>
                <wl-radio-checkbox
                  [(ngModel)]="searchParams.AgingPeriod"
                  [uncheckedValue]="agingPeriodEnum.None"
                  [value]="agingPeriodEnum.DaysPastDue30"
                ></wl-radio-checkbox>
                {{ 'revenue.invoice-selector.form.aging.options.30-days-past-due' | translate | titlecase }}
              </label>
            </li>
            <li>
              <label>
                <wl-radio-checkbox
                  [(ngModel)]="searchParams.AgingPeriod"
                  [uncheckedValue]="agingPeriodEnum.None"
                  [value]="agingPeriodEnum.DaysPastDue60"
                ></wl-radio-checkbox>
                {{ 'revenue.invoice-selector.form.aging.options.60-days-past-due' | translate | titlecase }}
              </label>
            </li>
            <li>
              <label>
                <wl-radio-checkbox
                  [(ngModel)]="searchParams.AgingPeriod"
                  [uncheckedValue]="agingPeriodEnum.None"
                  [value]="agingPeriodEnum.DaysPastDue90"
                ></wl-radio-checkbox>
                {{ 'revenue.invoice-selector.form.aging.options.90-days-past-due' | translate | titlecase }}
              </label>
            </li>
            <li>
              <label>
                <wl-radio-checkbox
                  [(ngModel)]="searchParams.AgingPeriod"
                  [uncheckedValue]="agingPeriodEnum.None"
                  [value]="agingPeriodEnum.DaysPastDue120AndMore"
                ></wl-radio-checkbox>
                {{ 'revenue.invoice-selector.form.aging.options.120-and-more-days-past-due' | translate | titlecase }}
              </label>
            </li>
            <li>
              <label>
                <wl-radio-checkbox
                  [(ngModel)]="searchParams.AgingPeriod"
                  [uncheckedValue]="agingPeriodEnum.None"
                  [value]="agingPeriodEnum.NotYetDue"
                ></wl-radio-checkbox>
                {{ 'revenue.invoice-selector.form.aging.options.not-yet-due' | translate | titlecase }}
              </label>
            </li>
          </ul>
        </div>
      </div>
    </wlx-tab>
    <wlx-tab [title]="'revenue.invoice-selector.form.revenue-item.tab-title' | translate | titlecase">
      <div class="container-fluid">
        <div class="form-horizontal">
          <wl-revenue-item-multi-selector [(ngModel)]="searchParams.RevenueItemNums"></wl-revenue-item-multi-selector>
        </div>
      </div>
    </wlx-tab>
    <wlx-tab [title]="'revenue.invoice-selector.form.payment-info.tab-title' | translate | titlecase">
      <div class="container-fluid">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-12">
              <button
                app-add-button
                [label]="'revenue.invoice-selector.form.add-search-field' | translate | titlecase"
                (click)="handleAddInvoicePaymentSearchField()"
              ></button>
            </div>
          </div>
          <div
            class="mb-10 mct-flex mct-row mct-justify-start mct-items-center"
            *ngFor="let searchExpression of searchParams.InvoicePaymentSearchExpressions; let ndx = index"
          >
            <div>
              <button
                pButton
                type="button"
                class="atlas-btn atlas-btn-default"
                icon="pi pi-times"
                (click)="handleRemoveInvoicePaymentSearchField(ndx)"
              ></button>
            </div>
            <wl-expression
              class="wl-expression-row"
              [searchExpression]="searchExpression"
              [binarySelectorHidden]="!ndx"
              [showBetweenDateOption]="false"
            >
              <wl-expression-option
                fieldName="PaymentDate"
                [displayName]="'revenue.invoice-selector.form.payment-info.options.payment-date' | translate | titlecase"
                [fieldType]="fieldTypeEnum.Date"
              ></wl-expression-option>
              <wl-expression-option
                fieldName="PaymentTypeID"
                [displayName]="'revenue.invoice-selector.form.payment-info.options.payment-type' | translate | titlecase"
              >
                <wl-expression-option-dropdown-option
                  *ngFor="let paymentType of paymentTypes"
                  [value]="paymentType.PaymentTypeId"
                  [label]="paymentType.PaymentType"
                >
                </wl-expression-option-dropdown-option>
              </wl-expression-option>
              <wl-expression-option
                fieldName="CheckNum"
                [displayName]="'revenue.invoice-selector.form.payment-info.options.check-num' | translate | titlecase"
              >
              </wl-expression-option>
            </wl-expression>
          </div>
        </div>
      </div>
    </wlx-tab>
  </wlx-tabs>
</ng-container>
